const onPageTransitionStart = () => {
  document.querySelector("body")!.classList.add("page-is-transitioning");
};

export default onPageTransitionStart;
